import { buttonColorType } from '../../interfaces/Element.interfaces';

interface IGetColorHexCodeParam {
  type: 'buttonText' | 'buttonBackground';
  color: buttonColorType;
}

export const getColorHexCode = ({ type, color }: IGetColorHexCodeParam): string => {
  if (type === 'buttonText') {
    switch (color) {
      case 'gray':
        return '#858894';
      case 'yellow':
        return '#232429';
      default:
        return '#FFFFFF';
    }
  } else {
    switch (color) {
      case 'blue':
        return '#196EFF';
      case 'red':
        return '#FF3049';
      case 'yellow':
        return '#FFD337';
      default:
        return '#F2F2F7';
    }
  }
};
